import moment from 'moment';

const now = moment();
export const todayID = now.format("YYYY-MM-DD");

// get week number for this date to store employee happiness
export const weekID =  moment(todayID).weekYear() + "-" + moment(todayID).week();

// same for last week to get employee happiness
const previousDate = moment(todayID).subtract(1, 'week');
export const lastWeekID = moment(previousDate).weekYear() + "-" + moment(previousDate).week();


// const weekID = getWeekID(todayID);
// const previousWeekID = getPreviousWeekID(todayID);

// days of this week in array to update employee happiness
let array = []
let days = moment().weekday();
if(days === 0) { days = 7 };
let i = 0;
while(i < days) {
  const prevDay = moment().subtract(i, 'days').format("YYYY-MM-DD")
  array.push(prevDay);
  i++
}
export const daysInThisWeek = array;

export const toArray = obj => obj ? Object.keys(obj).map(id => ({id, ...obj[id]})) : [];
export const sortArray = array => {
  return array.sort((a, b) => {
    var x = a.date.toLowerCase();
    var y = b.date.toLowerCase();
    if (x < y) {return 1;}
    if (x > y) {return -1;}
    return -1;
  })
}


function getHostName(url) {
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    return match[2];
  } else {
    return null;
  }
}

export const getDomain = url => {
  let hostName = getHostName(url);
  let domain = hostName;
  if (hostName != null) {
    let parts = hostName.split('.').reverse();
    if (parts != null && parts.length > 1) {
      domain = parts[1] + '.' + parts[0];
      if (hostName.toLowerCase().indexOf('.co.uk') != -1 && parts.length > 2) {
        domain = parts[2] + '.' + domain;
      }
    }
  }
  return domain;
}
